export const NAMESPACES = [
	"common",
	"mobile",
	"fulfill",
	"produce",
	"forecast",
	"portal",
	"restock",
	"productionItemLinksImport",
	"benchmark"
] as const;

export type AppNamespace = (typeof NAMESPACES)[number];

export const DEFAULT_NAMESPACE: AppNamespace = "common";
